import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetCalenderData, IResponseGetCalenderData } from "./types"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"
import { MsoolCalendarUrl } from "../../../utils/constants"

async function getCalenderData({ ...rest }: IPropsGetCalenderData, apiPrivate:AxiosInstance) {
	try {
		const response: AxiosResponse<IResponseGetCalenderData> =
			await apiPrivate.get(`${MsoolCalendarUrl}`, {
				params: {
					...rest,
					// Ensure currentDate is included if provided
					...(rest.currentDate && { currentDate: rest.currentDate })
				},
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetCalenderData(
	data: IPropsGetCalenderData,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetCalenderData,
					unknown,
					IResponseGetCalenderData
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	
	// Stable query key - only include defined values in a consistent order
	const stableQueryKey = [
		APIS_KEYS.GETCALENDERDATA,
		data.keyword ?? '',
		data.page ?? '',
		data.filter ?? '',
		data.propertyId ?? '',
		data.search ?? '',
		data.pageSize ?? '',
		data.pageNumber ?? '',
		data.currentDate ?? '',
		data.propertyIds ?? '',
	]
	
	return useQuery({
		queryKey: stableQueryKey,
		queryFn: () => getCalenderData(data, apiPrivate),
		// Prevent duplicate requests
		staleTime: 30000, // 30 seconds - don't refetch if data is fresh
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		...options,
	})
}
